var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSignup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M457,228.18s-6-99.13-85-147.31C335.07,58.34,289.58,44.13,244.61,44,200,43.88,153.08,59.64,131.05,97.76c-14.18,24.52-16.33,51.94-23.56,78.37C90.25,239.08,0,278.06,23,351.57c6.79,21.68,24.08,39.56,44.4,52,46,28.19,105.21,36.56,159.24,38.4,43.21,1.47,89.82-4.09,129.46-20.61,38.46-16,67.69-46.13,84.68-81.54C458.29,303.23,459.34,267.31,457,228.18Z",
    style: {
      fill: "#00A848"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457,228.18s-6-99.13-85-147.31C335.07,58.34,289.58,44.13,244.61,44,200,43.88,153.08,59.64,131.05,97.76c-14.18,24.52-16.33,51.94-23.56,78.37C90.25,239.08,0,278.06,23,351.57c6.79,21.68,24.08,39.56,44.4,52,46,28.19,105.21,36.56,159.24,38.4,43.21,1.47,89.82-4.09,129.46-20.61,38.46-16,67.69-46.13,84.68-81.54C458.29,303.23,459.34,267.31,457,228.18Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.36,377.47c1.76.77,6.07.67,6.07.67s-.92-2.82-1-3c-.94-2-3.93-5.23-6.36-4.91a2.91,2.91,0,0,0-2.33,3.64C75.14,375.57,76.86,376.82,78.36,377.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.85,389.94c1.82.27,5.67-.85,6-.94a51.56,51.56,0,0,0,2.33,6.45c.53,1.22,1.1,2.44,1.69,3.65-.35-.51-.67-1-.72-1-1.43-1.66-5.18-4-7.43-3.05a2.89,2.89,0,0,0-1.29,4.12c.83,1.52,2.83,2.27,4.45,2.5s4.94-.64,5.8-.89l.69,1.39c1.11,2.22,2.23,4.42,3.26,6.62.37.77.7,1.55,1,2.32l-.62-.89c-1.44-1.65-5.18-4-7.43-3.05a2.89,2.89,0,0,0-1.29,4.12c.83,1.52,2.83,2.27,4.45,2.5s4.61-.56,5.65-.84c.31.8.63,1.6.9,2.4.18.54.38,1.06.52,1.61s.31,1.1.46,1.64c.25,1,.52,2.12.74,3.15l.43,2.09c-.35-.78-1.07-2.28-1.15-2.4-1.16-1.85-4.51-4.75-6.88-4.14a2.9,2.9,0,0,0-1.9,3.88c.6,1.62,2.46,2.67,4,3.15,1.72.52,5.53,0,6,0,.23,1.14.44,2.25.62,3.3.41,2.32.72,4.4,1,6.16h1.6c-.28-1.82-.64-4-1.13-6.43-.23-1.16-.49-2.39-.78-3.65a31.59,31.59,0,0,0,3.36-1.58,21.13,21.13,0,0,0,4.88,3.15c-.43,1.08-.87,2.12-1.3,3.1-.89,2.05-1.73,3.86-2.48,5.41H107c.64-1.43,1.35-3.05,2.08-4.84.45-1.1.91-2.27,1.37-3.48.46.09,4.23.86,6,.46,1.6-.36,3.53-1.26,4.25-2.84a2.91,2.91,0,0,0-1.61-4c-2.32-.78-5.87,1.86-7.17,3.62-.08.11-.78,1.33-1.22,2.11l.56-1.49c.37-1,.71-2,1.08-3.13.16-.53.32-1.08.49-1.62s.28-1.13.43-1.7c.32-1.33.57-2.69.8-4.06.89.32,4,1.42,5.69,1.3s3.68-.71,4.62-2.16a2.9,2.9,0,0,0-1-4.21c-2.18-1.12-6.09.95-7.64,2.49-.1.1-1.09,1.33-1.62,2,.13-.83.27-1.65.37-2.5.3-2.43.53-4.9.77-7.36l.24-2.26c.31.12,4,1.51,5.88,1.38,1.63-.11,3.68-.71,4.62-2.17a2.89,2.89,0,0,0-1-4.2c-2.18-1.13-6.09,1-7.64,2.49-.12.12-1.54,1.89-1.88,2.36.18-1.65.37-3.3.62-4.92a52.72,52.72,0,0,1,1.41-6.48c.15.06,4,1.53,5.92,1.39,1.63-.11,3.68-.71,4.62-2.16a2.9,2.9,0,0,0-1-4.21c-2.18-1.12-6.09.95-7.64,2.49-.12.13-1.65,2-1.9,2.41l.09-.38a38.61,38.61,0,0,1,2.57-6.13c.56-1.09,1.15-2.1,1.75-3.08.7.35,3.9,1.91,5.6,2s3.74-.3,4.84-1.64a2.91,2.91,0,0,0-.51-4.29c-2-1.36-6.16.28-7.87,1.64-.09.07-1,.93-1.57,1.57.27-.44.55-.89.83-1.3,1-1.55,2.06-2.9,3-4.09.54-.67,1-1.27,1.5-1.82.86,0,4.33-.12,5.85-.83s3.17-2,3.53-3.69a2.9,2.9,0,0,0-2.43-3.57c-2.44-.26-5.33,3.08-6.23,5.08-.07.17-1,3-.92,3h.05c-.46.53-1,1.09-1.47,1.72-1,1.18-2,2.51-3.08,4a49.7,49.7,0,0,0-3.2,5.09,37.51,37.51,0,0,0-2.73,6.15l0,.08c0-.72,0-2.73,0-2.88-.28-2.18-2.1-6.21-4.51-6.65a2.9,2.9,0,0,0-3.35,2.73c-.14,1.72,1.11,3.45,2.33,4.54,1.38,1.23,5.2,2.42,5.5,2.51a52.21,52.21,0,0,0-1.61,6.66c-.24,1.32-.43,2.65-.61,4,0-.62,0-1.18,0-1.25-.28-2.18-2.1-6.21-4.51-6.65a2.9,2.9,0,0,0-3.35,2.73c-.14,1.72,1.11,3.45,2.33,4.54s4.47,2.18,5.33,2.46c-.06.51-.13,1-.19,1.54-.3,2.46-.58,4.91-.93,7.32-.12.84-.28,1.67-.43,2.5,0-.55,0-1,0-1.09-.28-2.17-2.1-6.2-4.51-6.64a2.9,2.9,0,0,0-3.35,2.73c-.14,1.72,1.11,3.45,2.33,4.54s4.16,2.08,5.18,2.41c-.18.84-.35,1.69-.57,2.5-.15.55-.27,1.09-.45,1.64s-.35,1.08-.52,1.61c-.37,1-.75,2.06-1.13,3-.26.68-.53,1.33-.79,2,.13-.84.36-2.5.36-2.64a11.18,11.18,0,0,0-1.51-5.48,2.76,2.76,0,0,0,0-.64,2.9,2.9,0,0,0-3.55-2.46c-2.37.63-3.87,4.79-4,7,0,.12.08,1.53.14,2.42-.12-.52-.23-1-.35-1.55-.25-1-.53-2.08-.83-3.2-.16-.54-.32-1.08-.49-1.62s-.38-1.1-.57-1.66c-.47-1.28-1-2.56-1.58-3.83.92-.22,4.17-1.05,5.47-2.05s2.67-2.62,2.66-4.36a2.9,2.9,0,0,0-3.13-3c-2.44.27-4.56,4.15-5,6.3,0,.13-.17,1.7-.23,2.57-.35-.76-.7-1.52-1.07-2.28-1.09-2.2-2.26-4.39-3.42-6.57-.36-.67-.71-1.35-1-2,.32-.07,4.2-1,5.66-2.09,1.3-1,2.68-2.63,2.66-4.36a2.9,2.9,0,0,0-3.13-3c-2.44.27-4.55,4.15-5,6.29,0,.17-.23,2.43-.26,3-.77-1.48-1.52-3-2.2-4.45A51.68,51.68,0,0,1,86.4,389c.15,0,4.2-1,5.7-2.1,1.3-1,2.67-2.63,2.66-4.36a2.9,2.9,0,0,0-3.13-3c-2.44.27-4.56,4.15-5,6.29,0,.17-.25,2.61-.26,3.06,0-.13-.09-.25-.13-.37A37.61,37.61,0,0,1,85,382c-.14-1.22-.2-2.39-.23-3.53.77-.1,4.29-.56,5.75-1.45s3-2.31,3.13-4a2.9,2.9,0,0,0-2.79-3.29c-2.45,0-5,3.62-5.66,5.7,0,.12-.28,1.31-.45,2.18,0-.51,0-1.05,0-1.54,0-1.85.12-3.55.23-5.06.08-.85.16-1.62.25-2.34.71-.49,3.54-2.49,4.41-3.92s1.55-3.41.92-5a2.91,2.91,0,0,0-4-1.65c-2.18,1.13-2.75,5.52-2.39,7.68,0,.18.85,3,.89,3l0,0c-.09.69-.19,1.44-.27,2.25-.15,1.5-.31,3.2-.35,5.06a51.71,51.71,0,0,0,.14,6,37.51,37.51,0,0,0,1.12,6.63.19.19,0,0,0,0,.08c-.38-.61-1.52-2.26-1.62-2.38-1.43-1.66-5.18-4-7.43-3.06a2.9,2.9,0,0,0-1.29,4.13C76.23,389,78.23,389.7,79.85,389.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.9,378.42s.79-2.86.81-3.05c.3-2.17-.39-6.54-2.6-7.6a2.89,2.89,0,0,0-3.94,1.74c-.6,1.63.15,3.63,1,5C118.26,376.12,121.9,378.42,121.9,378.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.56,420.68a12.38,12.38,0,0,0,3.63.4s-.56-1.68-.61-1.78c-.56-1.19-2.35-3.14-3.8-2.94a1.74,1.74,0,0,0-1.39,2.18A3.62,3.62,0,0,0,32.56,420.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.45,428.13a11.83,11.83,0,0,0,3.57-.56,30.83,30.83,0,0,0,1.39,3.86c.32.73.66,1.46,1,2.18-.21-.31-.4-.58-.43-.61-.86-1-3.09-2.4-4.44-1.83a1.72,1.72,0,0,0-.77,2.46,3.62,3.62,0,0,0,2.66,1.5,11.51,11.51,0,0,0,3.47-.53l.41.83c.66,1.32,1.33,2.64,2,3.95.22.47.41.93.61,1.39-.18-.27-.34-.5-.37-.53-.86-1-3.09-2.4-4.44-1.82a1.72,1.72,0,0,0-.77,2.46,3.62,3.62,0,0,0,2.66,1.5,11.27,11.27,0,0,0,3.37-.51c.19.48.38,1,.55,1.44.1.32.22.63.31,1l.27,1c.15.62.31,1.27.44,1.89.1.42.18.83.26,1.24-.21-.46-.64-1.36-.69-1.43-.69-1.11-2.69-2.84-4.11-2.48a1.74,1.74,0,0,0-1.14,2.32,3.63,3.63,0,0,0,2.41,1.88,11.65,11.65,0,0,0,3.59,0c.14.68.26,1.35.37,2,.25,1.38.43,2.62.57,3.68h1c-.17-1.09-.38-2.39-.67-3.84-.14-.7-.3-1.43-.47-2.19a20.31,20.31,0,0,0,2-.94,12.67,12.67,0,0,0,2.92,1.88c-.26.65-.53,1.27-.78,1.85-.53,1.23-1,2.31-1.48,3.24h1c.38-.85.8-1.82,1.24-2.9.27-.65.54-1.35.82-2.08a11.72,11.72,0,0,0,3.58.28,3.61,3.61,0,0,0,2.54-1.7,1.73,1.73,0,0,0-1-2.39c-1.39-.47-3.51,1.11-4.29,2.16,0,.06-.47.79-.73,1.26.11-.3.22-.58.33-.89.23-.61.43-1.22.65-1.87.1-.32.19-.64.29-1s.17-.68.26-1q.28-1.18.48-2.43a11.13,11.13,0,0,0,3.4.79,3.64,3.64,0,0,0,2.77-1.3,1.73,1.73,0,0,0-.59-2.51c-1.3-.68-3.64.56-4.56,1.49-.06.05-.65.79-1,1.2.08-.49.16-1,.22-1.49.18-1.45.32-2.93.46-4.4,0-.45.09-.9.14-1.35a12,12,0,0,0,3.52.82,3.65,3.65,0,0,0,2.76-1.29,1.74,1.74,0,0,0-.58-2.52c-1.3-.67-3.64.57-4.57,1.49-.07.07-.92,1.13-1.12,1.42.1-1,.22-2,.37-2.95A31.58,31.58,0,0,1,56,427.3a12.42,12.42,0,0,0,3.54.83,3.63,3.63,0,0,0,2.76-1.29,1.73,1.73,0,0,0-.58-2.52c-1.3-.67-3.64.57-4.57,1.49-.07.07-1,1.22-1.13,1.44a2,2,0,0,1,.06-.23,22,22,0,0,1,1.53-3.66c.33-.65.69-1.26,1-1.84A11.51,11.51,0,0,0,62,422.7a3.64,3.64,0,0,0,2.89-1,1.73,1.73,0,0,0-.31-2.56c-1.22-.81-3.68.16-4.7,1-.06,0-.57.56-.94.94l.49-.78c.62-.92,1.24-1.73,1.79-2.44.32-.4.61-.76.89-1.09a11.52,11.52,0,0,0,3.5-.5,3.61,3.61,0,0,0,2.11-2.2,1.74,1.74,0,0,0-1.45-2.14c-1.46-.16-3.19,1.84-3.72,3,0,.1-.58,1.8-.56,1.8h0l-.88,1c-.57.7-1.2,1.5-1.84,2.41a30.35,30.35,0,0,0-1.91,3.05,22.37,22.37,0,0,0-1.63,3.67l0,.05c0-.43,0-1.63,0-1.72-.17-1.3-1.26-3.71-2.7-4a1.73,1.73,0,0,0-2,1.63,3.65,3.65,0,0,0,1.39,2.72,12.47,12.47,0,0,0,3.29,1.5,29.64,29.64,0,0,0-1,4c-.14.79-.26,1.58-.37,2.38,0-.37,0-.7,0-.75-.16-1.3-1.25-3.71-2.69-4a1.75,1.75,0,0,0-2,1.64,3.64,3.64,0,0,0,1.4,2.71,11.42,11.42,0,0,0,3.18,1.47c0,.31-.07.62-.11.92-.18,1.47-.35,2.94-.56,4.38-.07.5-.16,1-.25,1.5,0-.33,0-.61,0-.65-.17-1.3-1.25-3.71-2.7-4a1.74,1.74,0,0,0-2,1.63,3.66,3.66,0,0,0,1.4,2.72,11,11,0,0,0,3.09,1.44c-.1.5-.21,1-.34,1.5-.09.32-.16.65-.27,1s-.21.65-.31,1c-.22.6-.45,1.23-.68,1.81-.15.41-.31.8-.47,1.19.08-.51.22-1.49.22-1.58a6.74,6.74,0,0,0-.9-3.27,2.56,2.56,0,0,0,0-.39,1.73,1.73,0,0,0-2.12-1.47c-1.42.38-2.31,2.86-2.38,4.17,0,.08,0,.92.09,1.45-.08-.31-.14-.61-.22-.92-.15-.63-.31-1.25-.49-1.92-.1-.32-.2-.64-.29-1s-.23-.66-.35-1c-.28-.77-.6-1.53-.94-2.29a11.57,11.57,0,0,0,3.27-1.22A3.61,3.61,0,0,0,48.46,437a1.74,1.74,0,0,0-1.87-1.78c-1.46.16-2.73,2.49-3,3.77,0,.08-.1,1-.14,1.54-.21-.46-.41-.92-.64-1.37-.65-1.31-1.35-2.62-2-3.93-.22-.4-.42-.8-.63-1.2a12.35,12.35,0,0,0,3.39-1.25,3.68,3.68,0,0,0,1.59-2.61,1.74,1.74,0,0,0-1.88-1.77c-1.45.16-2.72,2.48-3,3.76,0,.1-.15,1.45-.16,1.8-.46-.89-.91-1.77-1.32-2.66a31.27,31.27,0,0,1-1.43-3.7,12.1,12.1,0,0,0,3.41-1.26,3.58,3.58,0,0,0,1.59-2.6,1.74,1.74,0,0,0-1.87-1.78c-1.46.16-2.72,2.48-3,3.77,0,.1-.15,1.55-.16,1.82l-.07-.22a22.62,22.62,0,0,1-.74-3.9c-.08-.73-.12-1.43-.14-2.11a11.75,11.75,0,0,0,3.44-.87A3.61,3.61,0,0,0,41.7,418,1.73,1.73,0,0,0,40,416c-1.47,0-3,2.16-3.38,3.41,0,.07-.17.78-.27,1.3,0-.31,0-.63,0-.92,0-1.11.08-2.12.15-3,0-.51.09-1,.14-1.4a11.8,11.8,0,0,0,2.64-2.35,3.62,3.62,0,0,0,.55-3,1.74,1.74,0,0,0-2.39-1c-1.3.67-1.65,3.29-1.43,4.58,0,.11.51,1.83.53,1.81l0,0c-.06.42-.12.86-.17,1.35-.09.9-.18,1.91-.21,3a31.61,31.61,0,0,0,.09,3.59,22.26,22.26,0,0,0,.67,4v0c-.23-.36-.91-1.35-1-1.42-.86-1-3.09-2.4-4.44-1.83a1.74,1.74,0,0,0-.77,2.47A3.61,3.61,0,0,0,33.45,428.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.59,421.25s.47-1.71.48-1.83c.18-1.29-.23-3.9-1.55-4.54a1.73,1.73,0,0,0-2.36,1,3.61,3.61,0,0,0,.62,3A12.72,12.72,0,0,0,58.59,421.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405,317.63c-1.76.77-6.07.67-6.07.67s.92-2.82,1-3c.94-2,3.93-5.24,6.36-4.91a2.91,2.91,0,0,1,2.33,3.64C408.18,315.72,406.46,317,405,317.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.47,330.1c-1.82.26-5.67-.85-6-.94a50.86,50.86,0,0,1-2.33,6.44c-.53,1.23-1.1,2.44-1.69,3.66.35-.52.67-1,.72-1,1.43-1.66,5.18-4,7.43-3.06a2.9,2.9,0,0,1,1.29,4.12c-.83,1.52-2.83,2.27-4.45,2.51s-4.94-.65-5.8-.89L392,342.3c-1.11,2.21-2.23,4.42-3.26,6.61-.37.78-.7,1.55-1,2.33.31-.46.58-.84.62-.89,1.44-1.66,5.18-4,7.43-3.06a2.9,2.9,0,0,1,1.29,4.13c-.83,1.51-2.83,2.26-4.45,2.5s-4.61-.56-5.65-.85c-.31.81-.63,1.61-.9,2.4-.18.55-.38,1.06-.52,1.62s-.31,1.09-.46,1.63c-.25,1-.52,2.13-.74,3.16-.15.71-.29,1.4-.43,2.08.35-.77,1.07-2.27,1.15-2.39,1.16-1.86,4.51-4.75,6.88-4.15a2.91,2.91,0,0,1,1.9,3.88c-.6,1.63-2.46,2.67-4,3.15-1.72.53-5.53.05-6,0-.23,1.14-.44,2.25-.62,3.3-.41,2.32-.72,4.4-1,6.16h-1.6c.28-1.82.64-4,1.13-6.42.23-1.16.49-2.39.78-3.66a30.77,30.77,0,0,1-3.36-1.57,21.13,21.13,0,0,1-4.88,3.15c.43,1.08.87,2.12,1.3,3.1.89,2,1.73,3.86,2.48,5.4h-1.74c-.64-1.42-1.35-3-2.08-4.84-.45-1.09-.91-2.27-1.37-3.48-.46.1-4.23.87-6,.47-1.6-.36-3.53-1.26-4.25-2.84a2.91,2.91,0,0,1,1.61-4c2.32-.78,5.87,1.86,7.17,3.62.08.1.78,1.32,1.22,2.1-.19-.49-.37-1-.56-1.49-.37-1-.71-2-1.08-3.12-.16-.54-.32-1.08-.49-1.63s-.28-1.13-.43-1.69c-.32-1.33-.57-2.69-.8-4.07-.89.32-4.05,1.42-5.69,1.31s-3.68-.72-4.62-2.17a2.89,2.89,0,0,1,1-4.2c2.18-1.13,6.09.94,7.64,2.49.1.1,1.09,1.33,1.62,2-.13-.83-.27-1.66-.37-2.5-.3-2.43-.53-4.9-.77-7.37l-.24-2.25c-.31.11-4,1.5-5.88,1.38-1.63-.12-3.68-.72-4.62-2.17a2.9,2.9,0,0,1,1-4.21c2.18-1.12,6.09.95,7.64,2.5.12.11,1.54,1.89,1.88,2.36-.18-1.66-.37-3.31-.62-4.93a52.56,52.56,0,0,0-1.41-6.47c-.15.05-4,1.52-5.92,1.39-1.63-.12-3.68-.71-4.62-2.17a2.89,2.89,0,0,1,1-4.2c2.18-1.13,6.09.95,7.64,2.49.12.12,1.65,2,1.9,2.4l-.09-.38a38.11,38.11,0,0,0-2.57-6.12c-.56-1.1-1.15-2.11-1.75-3.08-.7.35-3.9,1.9-5.6,2s-3.74-.31-4.84-1.64a2.91,2.91,0,0,1,.51-4.29c2-1.36,6.15.27,7.87,1.64.09.07.95.93,1.57,1.56-.27-.43-.55-.88-.83-1.29-1-1.55-2.06-2.9-3-4.09-.54-.67-1-1.27-1.5-1.82-.86,0-4.33-.12-5.85-.84s-3.17-2-3.53-3.68a2.91,2.91,0,0,1,2.43-3.58c2.44-.26,5.33,3.08,6.23,5.08.07.18,1,3,.92,3h-.05c.46.52.95,1.09,1.47,1.72.95,1.17,2,2.5,3.08,4a49.89,49.89,0,0,1,3.2,5.1,37.13,37.13,0,0,1,2.73,6.15l0,.07c0-.71,0-2.72,0-2.88.28-2.17,2.1-6.2,4.51-6.65a2.9,2.9,0,0,1,3.35,2.73c.14,1.73-1.11,3.46-2.33,4.55-1.38,1.22-5.2,2.41-5.5,2.51a52.21,52.21,0,0,1,1.61,6.66c.24,1.31.43,2.64.61,4,0-.63,0-1.18,0-1.26.28-2.17,2.1-6.2,4.51-6.65a2.9,2.9,0,0,1,3.35,2.73c.14,1.73-1.11,3.45-2.33,4.54s-4.47,2.19-5.33,2.46c.06.52.13,1,.19,1.54.3,2.46.58,4.92.93,7.32.12.85.28,1.68.43,2.51,0-.55,0-1,0-1.09.28-2.17,2.1-6.2,4.51-6.65a2.9,2.9,0,0,1,3.35,2.73c.14,1.73-1.11,3.45-2.33,4.54s-4.16,2.08-5.18,2.41c.18.85.35,1.7.57,2.51.15.55.27,1.09.45,1.63s.35,1.08.52,1.61c.37,1,.75,2.06,1.13,3,.26.69.53,1.33.79,2-.14-.84-.36-2.49-.36-2.63a11.18,11.18,0,0,1,1.51-5.48,2.72,2.72,0,0,1,0-.64,2.91,2.91,0,0,1,3.55-2.47c2.37.63,3.87,4.79,4,7,0,.13-.08,1.54-.14,2.43.12-.52.23-1,.35-1.55.25-1.05.53-2.09.83-3.21.16-.53.32-1.07.49-1.62s.38-1.1.57-1.66c.47-1.28,1-2.55,1.58-3.83-.92-.22-4.17-1-5.47-2s-2.67-2.63-2.66-4.36a2.9,2.9,0,0,1,3.13-3c2.44.26,4.56,4.15,5,6.29,0,.14.17,1.71.23,2.58.35-.77.7-1.53,1.07-2.29,1.09-2.19,2.26-4.38,3.42-6.57q.54-1,1.05-2c-.32-.08-4.2-1-5.66-2.1-1.3-1-2.68-2.62-2.66-4.35a2.89,2.89,0,0,1,3.13-3c2.44.26,4.55,4.15,5,6.29,0,.16.23,2.43.26,3,.77-1.48,1.52-3,2.2-4.45a52.35,52.35,0,0,0,2.39-6.18c-.15,0-4.2-1-5.7-2.11-1.3-1-2.67-2.62-2.66-4.35a2.9,2.9,0,0,1,3.13-3c2.44.26,4.56,4.15,5,6.29,0,.17.25,2.61.26,3.05,0-.12.09-.24.13-.37a37.68,37.68,0,0,0,1.24-6.52c.14-1.22.2-2.39.23-3.54-.77-.09-4.29-.56-5.75-1.44s-2.95-2.32-3.13-4a2.91,2.91,0,0,1,2.79-3.3c2.45,0,5,3.63,5.66,5.71,0,.11.28,1.31.45,2.18,0-.52,0-1.05,0-1.54,0-1.86-.12-3.56-.23-5.06-.08-.85-.16-1.63-.25-2.35-.71-.48-3.54-2.49-4.41-3.92s-1.55-3.41-.92-5a2.91,2.91,0,0,1,4-1.64c2.18,1.13,2.75,5.51,2.39,7.67,0,.19-.85,3.05-.89,3l0,0c.09.69.19,1.43.27,2.24.15,1.51.31,3.21.35,5.07a51.54,51.54,0,0,1-.14,6,37.47,37.47,0,0,1-1.12,6.64.24.24,0,0,1,0,.08c.38-.61,1.52-2.27,1.62-2.39,1.43-1.65,5.18-4,7.43-3a2.9,2.9,0,0,1,1.29,4.12C407.09,329.11,405.09,329.86,403.47,330.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.42,318.57s-.79-2.86-.81-3c-.3-2.17.39-6.54,2.6-7.61a2.89,2.89,0,0,1,3.94,1.75c.6,1.63-.15,3.62-1,5C365.06,316.28,361.42,318.57,361.42,318.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.4,343.86a12.55,12.55,0,0,1-3.63.41s.55-1.69.6-1.79c.56-1.18,2.35-3.13,3.8-2.94a1.75,1.75,0,0,1,1.4,2.18A3.67,3.67,0,0,1,431.4,343.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.51,351.32a12.16,12.16,0,0,1-3.57-.56,31.36,31.36,0,0,1-1.4,3.85c-.31.73-.65,1.46-1,2.18.21-.3.39-.58.43-.61.85-1,3.09-2.4,4.44-1.83a1.74,1.74,0,0,1,.77,2.47,3.64,3.64,0,0,1-2.66,1.49,11.21,11.21,0,0,1-3.47-.53c-.14.28-.27.56-.41.83-.67,1.33-1.34,2.64-1.95,4-.22.46-.42.92-.62,1.39.19-.28.35-.5.37-.54.86-1,3.1-2.39,4.45-1.82a1.73,1.73,0,0,1,.77,2.46,3.63,3.63,0,0,1-2.66,1.5,11,11,0,0,1-3.38-.51c-.19.48-.38,1-.54,1.44-.11.33-.23.63-.31,1l-.28,1c-.15.63-.3,1.27-.44,1.89-.09.42-.17.83-.26,1.24.21-.46.65-1.36.69-1.43.7-1.11,2.7-2.84,4.12-2.48a1.74,1.74,0,0,1,1.13,2.32,3.62,3.62,0,0,1-2.4,1.89,12.32,12.32,0,0,1-3.59,0c-.14.68-.27,1.34-.38,2-.24,1.38-.43,2.63-.57,3.68h-1c.17-1.09.39-2.39.68-3.84.13-.69.29-1.43.46-2.19a17.42,17.42,0,0,1-2-.94,12.79,12.79,0,0,1-2.92,1.89c.26.64.52,1.26.78,1.85.53,1.22,1,2.31,1.48,3.23h-1c-.38-.85-.81-1.82-1.25-2.89-.26-.66-.54-1.36-.81-2.08a12.47,12.47,0,0,1-3.59.28,3.66,3.66,0,0,1-2.53-1.7,1.73,1.73,0,0,1,1-2.4c1.39-.47,3.51,1.11,4.28,2.16.05.07.47.8.73,1.26-.11-.29-.22-.58-.33-.89-.22-.6-.43-1.21-.65-1.87-.09-.32-.19-.64-.29-1s-.17-.67-.26-1c-.19-.8-.34-1.61-.48-2.43a11.45,11.45,0,0,1-3.4.78,3.62,3.62,0,0,1-2.76-1.3,1.73,1.73,0,0,1,.58-2.51c1.31-.67,3.64.57,4.57,1.49.06.06.65.79,1,1.21-.08-.5-.16-1-.23-1.5-.18-1.45-.31-2.93-.46-4.4,0-.45-.09-.9-.14-1.35a12,12,0,0,1-3.51.82,3.6,3.6,0,0,1-2.77-1.29,1.73,1.73,0,0,1,.59-2.51c1.3-.68,3.63.56,4.56,1.49.07.06.92,1.13,1.12,1.41-.1-1-.21-2-.36-2.95a31.59,31.59,0,0,0-.85-3.87,12,12,0,0,1-3.54.83,3.58,3.58,0,0,1-2.76-1.29,1.74,1.74,0,0,1,.58-2.52c1.31-.67,3.64.57,4.57,1.5.07.07,1,1.21,1.14,1.43l-.06-.23a22,22,0,0,0-1.54-3.66c-.33-.65-.68-1.26-1-1.84a11.62,11.62,0,0,1-3.35,1.18,3.62,3.62,0,0,1-2.89-1,1.74,1.74,0,0,1,.3-2.57c1.22-.81,3.68.17,4.71,1l.94.94c-.17-.26-.33-.53-.5-.78-.61-.92-1.23-1.73-1.78-2.44-.32-.4-.62-.76-.9-1.09a11.46,11.46,0,0,1-3.49-.5,3.63,3.63,0,0,1-2.12-2.2,1.75,1.75,0,0,1,1.46-2.14c1.45-.15,3.19,1.84,3.72,3,0,.1.58,1.8.55,1.8h0l.88,1c.57.7,1.21,1.5,1.84,2.41a30.35,30.35,0,0,1,1.92,3.05,22.76,22.76,0,0,1,1.63,3.67.43.43,0,0,0,0,0c0-.43,0-1.63,0-1.72.16-1.3,1.25-3.71,2.69-4a1.74,1.74,0,0,1,2,1.64,3.59,3.59,0,0,1-1.39,2.71,11.59,11.59,0,0,1-3.29,1.5,29.8,29.8,0,0,1,1,4q.21,1.17.36,2.37c0-.37,0-.7,0-.75.17-1.3,1.26-3.71,2.7-4a1.73,1.73,0,0,1,2,1.63,3.59,3.59,0,0,1-1.39,2.71,11.53,11.53,0,0,1-3.19,1.48l.12.91c.17,1.48.34,2.94.55,4.38.07.51.17,1,.25,1.5,0-.33,0-.61,0-.65.17-1.3,1.26-3.71,2.7-4a1.74,1.74,0,0,1,2,1.64,3.59,3.59,0,0,1-1.39,2.71,11.22,11.22,0,0,1-3.1,1.44c.11.51.22,1,.34,1.5.1.33.16.65.28,1s.2.64.31,1c.22.61.44,1.23.67,1.82.16.4.31.79.47,1.18-.08-.5-.21-1.49-.21-1.57a6.67,6.67,0,0,1,.9-3.28,2.36,2.36,0,0,1,0-.38,1.73,1.73,0,0,1,2.12-1.48c1.42.38,2.32,2.87,2.39,4.17,0,.08-.05.92-.09,1.45.07-.3.14-.6.21-.92.15-.63.32-1.25.5-1.92.09-.32.19-.64.29-1s.23-.65.34-1c.28-.76.6-1.53.94-2.29a11.22,11.22,0,0,1-3.26-1.22,3.66,3.66,0,0,1-1.6-2.61,1.74,1.74,0,0,1,1.88-1.77c1.46.16,2.72,2.48,3,3.76,0,.08.1,1,.14,1.54.2-.46.41-.91.64-1.37.65-1.31,1.35-2.62,2-3.92l.63-1.21a11.81,11.81,0,0,1-3.39-1.25,3.61,3.61,0,0,1-1.59-2.6,1.73,1.73,0,0,1,1.87-1.78c1.46.16,2.72,2.48,3,3.76,0,.1.14,1.45.16,1.8.45-.88.9-1.77,1.31-2.66a29,29,0,0,0,1.43-3.7,12.43,12.43,0,0,1-3.41-1.25,3.68,3.68,0,0,1-1.59-2.61,1.74,1.74,0,0,1,1.88-1.77c1.45.16,2.72,2.48,3,3.76,0,.1.16,1.56.16,1.82,0-.07.05-.14.08-.22a22.62,22.62,0,0,0,.74-3.9c.08-.73.12-1.43.14-2.11a12,12,0,0,1-3.44-.86,3.62,3.62,0,0,1-1.87-2.42,1.73,1.73,0,0,1,1.66-2c1.47,0,3,2.17,3.39,3.41,0,.07.17.78.27,1.3,0-.3,0-.62,0-.92,0-1.11-.07-2.12-.14-3,0-.51-.09-1-.15-1.4a11.55,11.55,0,0,1-2.64-2.35,3.61,3.61,0,0,1-.54-3,1.74,1.74,0,0,1,2.39-1c1.3.67,1.64,3.3,1.43,4.59,0,.11-.51,1.82-.54,1.81l0,0c.05.41.11.85.16,1.34.09.9.18,1.92.21,3a31.5,31.5,0,0,1-.08,3.59,23,23,0,0,1-.67,4s0,0,0,.05c.24-.37.91-1.36,1-1.43.86-1,3.1-2.4,4.45-1.82a1.74,1.74,0,0,1,.77,2.46A3.63,3.63,0,0,1,430.51,351.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.37,344.43s-.47-1.71-.49-1.82c-.18-1.3.24-3.91,1.56-4.55a1.73,1.73,0,0,1,2.36,1.05,3.63,3.63,0,0,1-.63,3A12.22,12.22,0,0,1,405.37,344.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.16,397.45c-1.76.77-6.06.67-6.07.67s.93-2.82,1-3c.94-2,3.93-5.24,6.36-4.91a2.9,2.9,0,0,1,2.33,3.64C463.39,395.54,461.66,396.79,460.16,397.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.68,409.92c-1.83.26-5.67-.85-6-.94a50,50,0,0,1-2.33,6.45c-.53,1.22-1.1,2.44-1.68,3.65.35-.51.66-1,.72-1,1.43-1.66,5.17-4,7.43-3.06a2.91,2.91,0,0,1,1.28,4.13c-.83,1.51-2.83,2.27-4.44,2.5s-4.94-.64-5.81-.89c-.23.46-.45.93-.69,1.39-1.11,2.21-2.23,4.42-3.26,6.62-.37.77-.7,1.55-1,2.32.31-.45.58-.84.63-.89,1.43-1.66,5.17-4,7.43-3.05a2.9,2.9,0,0,1,1.28,4.12c-.83,1.52-2.83,2.27-4.44,2.5s-4.62-.56-5.65-.85c-.32.81-.64,1.61-.91,2.41-.17.54-.38,1.06-.52,1.61s-.31,1.1-.46,1.64c-.25,1-.51,2.12-.73,3.15-.16.72-.3,1.4-.44,2.09.35-.78,1.08-2.28,1.15-2.4,1.17-1.85,4.51-4.75,6.89-4.14a2.9,2.9,0,0,1,1.89,3.88c-.59,1.62-2.45,2.67-4,3.14-1.72.53-5.53.05-6,0-.23,1.14-.44,2.25-.62,3.3-.41,2.32-.72,4.39-.95,6.15H435.8c.28-1.82.65-4,1.13-6.42.23-1.16.5-2.39.78-3.65a34.1,34.1,0,0,1-3.35-1.58,21.14,21.14,0,0,1-4.89,3.15c.44,1.08.87,2.12,1.3,3.1.89,2,1.73,3.86,2.48,5.4h-1.74c-.64-1.42-1.34-3-2.08-4.84-.45-1.09-.91-2.26-1.36-3.47-.47.09-4.24.86-6,.46-1.59-.36-3.53-1.26-4.24-2.84a2.9,2.9,0,0,1,1.6-4c2.32-.78,5.87,1.86,7.17,3.62.08.11.79,1.33,1.22,2.1-.19-.49-.37-1-.55-1.48-.38-1-.72-2-1.09-3.13l-.48-1.62c-.18-.54-.29-1.13-.44-1.7-.32-1.33-.57-2.69-.8-4.07-.88.33-4,1.43-5.69,1.31s-3.68-.71-4.62-2.16a2.9,2.9,0,0,1,1-4.21c2.18-1.13,6.09.95,7.64,2.49.1.1,1.09,1.33,1.62,2-.13-.83-.26-1.65-.37-2.5-.3-2.43-.53-4.9-.77-7.36-.07-.76-.16-1.51-.23-2.26-.32.12-4.05,1.51-5.89,1.38-1.63-.12-3.68-.72-4.62-2.17a2.88,2.88,0,0,1,1-4.2c2.17-1.13,6.08.94,7.63,2.49.12.11,1.54,1.89,1.88,2.36-.17-1.66-.36-3.3-.62-4.92a50.56,50.56,0,0,0-1.41-6.48c-.15.06-4,1.52-5.92,1.39-1.63-.11-3.67-.71-4.62-2.16a2.91,2.91,0,0,1,1-4.21c2.18-1.12,6.08.95,7.64,2.49.12.12,1.64,2,1.9,2.4,0-.12-.06-.25-.1-.37a36.14,36.14,0,0,0-2.57-6.13c-.55-1.09-1.15-2.11-1.75-3.08-.69.35-3.89,1.9-5.6,2s-3.73-.3-4.83-1.64a2.9,2.9,0,0,1,.5-4.29c2.05-1.36,6.16.27,7.87,1.64.09.07,1,.93,1.58,1.57-.28-.44-.56-.89-.83-1.3-1-1.55-2.06-2.9-3-4.09-.53-.67-1-1.27-1.49-1.82-.87,0-4.34-.12-5.85-.83s-3.18-2-3.53-3.69a2.9,2.9,0,0,1,2.42-3.57c2.44-.27,5.34,3.08,6.23,5.08.08.17,1,3,.92,3h-.05c.46.52.95,1.09,1.47,1.72,1,1.17,2,2.51,3.09,4a51.49,51.49,0,0,1,3.2,5.09,38.37,38.37,0,0,1,2.73,6.15s0,.05,0,.08c0-.72,0-2.73,0-2.89.28-2.17,2.1-6.2,4.51-6.64a2.9,2.9,0,0,1,3.35,2.73c.14,1.72-1.11,3.45-2.33,4.54-1.38,1.23-5.19,2.42-5.5,2.51a50.57,50.57,0,0,1,1.61,6.66c.24,1.32.43,2.64.61,4,0-.62,0-1.18,0-1.26.29-2.17,2.11-6.2,4.52-6.64a2.9,2.9,0,0,1,3.35,2.72c.14,1.73-1.11,3.46-2.33,4.55s-4.48,2.18-5.34,2.46c.07.51.13,1,.2,1.53.29,2.47.57,4.92.92,7.32.13.85.28,1.68.43,2.51,0-.55,0-1,0-1.09.28-2.17,2.1-6.2,4.51-6.65a2.9,2.9,0,0,1,3.35,2.73c.14,1.73-1.11,3.46-2.33,4.55s-4.16,2.07-5.18,2.41c.18.84.36,1.69.57,2.5.16.55.27,1.09.46,1.64s.35,1.08.52,1.61c.37,1,.74,2.06,1.12,3l.79,2c-.13-.85-.36-2.5-.36-2.64a11.28,11.28,0,0,1,1.51-5.48,4.58,4.58,0,0,1,0-.64,2.89,2.89,0,0,1,3.55-2.46c2.37.63,3.87,4.79,4,7,0,.13-.08,1.54-.15,2.43.12-.52.23-1,.36-1.55.25-1,.53-2.08.82-3.2.16-.54.33-1.08.49-1.63s.38-1.1.58-1.65c.46-1.28,1-2.56,1.57-3.83-.92-.22-4.16-1-5.47-2s-2.67-2.63-2.66-4.36a2.91,2.91,0,0,1,3.14-3c2.43.27,4.55,4.15,5,6.29,0,.14.18,1.71.24,2.58.35-.76.69-1.53,1.07-2.29,1.09-2.19,2.26-4.38,3.42-6.57l1.05-2c-.33-.07-4.21-1-5.67-2.09-1.3-1-2.67-2.63-2.66-4.36a2.9,2.9,0,0,1,3.13-3c2.44.26,4.56,4.15,5,6.29,0,.16.24,2.43.26,3,.77-1.48,1.52-3,2.2-4.45a50.12,50.12,0,0,0,2.4-6.18c-.16,0-4.21-1-5.7-2.1-1.3-1-2.68-2.63-2.67-4.36a2.91,2.91,0,0,1,3.14-3c2.44.26,4.55,4.15,5,6.29,0,.17.26,2.61.27,3.05,0-.12.09-.24.12-.36a36.7,36.7,0,0,0,1.24-6.53c.14-1.22.2-2.39.24-3.53-.77-.1-4.3-.57-5.76-1.45s-2.95-2.32-3.12-4a2.89,2.89,0,0,1,2.78-3.29c2.46,0,5,3.62,5.66,5.7,0,.12.29,1.31.45,2.18,0-.52,0-1.05,0-1.54,0-1.86-.12-3.55-.24-5.06-.07-.85-.16-1.62-.24-2.34-.71-.49-3.55-2.49-4.42-3.92s-1.55-3.42-.91-5a2.9,2.9,0,0,1,4-1.64c2.18,1.13,2.75,5.51,2.39,7.67,0,.19-.85,3.05-.89,3l0,0c.1.69.19,1.43.28,2.25.15,1.5.3,3.2.34,5.06a51.71,51.71,0,0,1-.14,6,38.41,38.41,0,0,1-1.11,6.63l0,.08c.39-.61,1.52-2.27,1.63-2.38,1.43-1.66,5.17-4,7.43-3.06a2.9,2.9,0,0,1,1.28,4.12C462.29,408.93,460.29,409.68,458.68,409.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.62,398.4s-.78-2.86-.81-3c-.3-2.17.39-6.54,2.6-7.61a2.91,2.91,0,0,1,3.95,1.75c.59,1.63-.16,3.63-1.05,5C420.27,396.1,416.62,398.39,416.62,398.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.6,423.69a12.41,12.41,0,0,1-3.63.4s.56-1.69.6-1.79c.57-1.18,2.35-3.13,3.81-2.93a1.73,1.73,0,0,1,1.39,2.17A3.63,3.63,0,0,1,486.6,423.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.71,431.14a12.16,12.16,0,0,1-3.57-.56,30.14,30.14,0,0,1-1.39,3.85c-.32.74-.66,1.46-1,2.19l.43-.62c.86-1,3.09-2.4,4.44-1.83a1.74,1.74,0,0,1,.77,2.47,3.62,3.62,0,0,1-2.66,1.5,11.49,11.49,0,0,1-3.47-.54c-.14.28-.27.56-.41.83-.66,1.33-1.33,2.65-1.95,4-.22.46-.42.93-.61,1.39.18-.27.34-.5.37-.53.86-1,3.09-2.4,4.44-1.83a1.74,1.74,0,0,1,.77,2.47,3.64,3.64,0,0,1-2.66,1.49,11,11,0,0,1-3.38-.5c-.19.48-.38,1-.54,1.43s-.22.63-.31,1l-.27,1c-.15.63-.31,1.28-.44,1.89-.1.43-.18.84-.26,1.25.21-.47.64-1.36.69-1.43.69-1.11,2.69-2.85,4.11-2.48a1.73,1.73,0,0,1,1.13,2.32,3.61,3.61,0,0,1-2.4,1.88,12,12,0,0,1-3.59,0c-.14.68-.26,1.34-.37,2-.25,1.39-.43,2.63-.57,3.68h-1c.16-1.09.38-2.38.67-3.84.14-.69.3-1.43.47-2.18a18,18,0,0,1-2-.95,12.45,12.45,0,0,1-2.92,1.89c.26.64.52,1.27.78,1.85.53,1.22,1,2.31,1.48,3.23h-1c-.38-.85-.8-1.82-1.24-2.89-.27-.65-.54-1.36-.82-2.08a11.72,11.72,0,0,1-3.58.28,3.65,3.65,0,0,1-2.54-1.7,1.74,1.74,0,0,1,1-2.4c1.39-.46,3.51,1.11,4.29,2.17,0,.06.47.79.72,1.25-.11-.29-.22-.58-.33-.89-.22-.6-.42-1.21-.64-1.86-.1-.32-.2-.65-.29-1s-.18-.67-.26-1c-.19-.79-.35-1.61-.48-2.43a11.45,11.45,0,0,1-3.4.78,3.67,3.67,0,0,1-2.77-1.29,1.74,1.74,0,0,1,.59-2.52c1.3-.67,3.64.57,4.56,1.49.06.06.65.8,1,1.21-.08-.5-.16-1-.22-1.49-.18-1.46-.32-2.93-.46-4.41,0-.45-.1-.9-.14-1.35a12.31,12.31,0,0,1-3.52.83,3.62,3.62,0,0,1-2.76-1.3,1.72,1.72,0,0,1,.58-2.51c1.3-.67,3.64.56,4.57,1.49.07.07.92,1.13,1.12,1.41-.11-1-.22-2-.37-2.94a29.12,29.12,0,0,0-.85-3.87,12.24,12.24,0,0,1-3.53.83,3.64,3.64,0,0,1-2.77-1.3,1.73,1.73,0,0,1,.59-2.51c1.3-.67,3.64.56,4.56,1.49.08.07,1,1.21,1.14,1.43l-.06-.22a22.94,22.94,0,0,0-1.53-3.67c-.33-.65-.69-1.25-1.05-1.83a12,12,0,0,1-3.35,1.17,3.64,3.64,0,0,1-2.89-1,1.73,1.73,0,0,1,.31-2.56c1.22-.81,3.68.16,4.7,1,.05,0,.57.55.94.93-.16-.26-.33-.53-.49-.77-.62-.93-1.24-1.73-1.79-2.45l-.89-1.09a11.47,11.47,0,0,1-3.5-.49,3.63,3.63,0,0,1-2.11-2.21,1.73,1.73,0,0,1,1.45-2.13c1.46-.16,3.19,1.84,3.72,3,.05.11.58,1.81.56,1.81h0c.28.31.57.65.88,1,.57.71,1.21,1.5,1.85,2.42a31.32,31.32,0,0,1,1.91,3,22.87,22.87,0,0,1,1.63,3.68s0,0,0,0c0-.43,0-1.63,0-1.72.17-1.3,1.26-3.71,2.7-4a1.73,1.73,0,0,1,2,1.63,3.66,3.66,0,0,1-1.39,2.71,12.25,12.25,0,0,1-3.29,1.51,29.64,29.64,0,0,1,1,4c.14.78.26,1.58.37,2.38,0-.38,0-.71,0-.75.16-1.3,1.25-3.71,2.69-4a1.73,1.73,0,0,1,2,1.63,3.61,3.61,0,0,1-1.39,2.72,11.63,11.63,0,0,1-3.19,1.47l.12.92c.18,1.47.34,2.94.55,4.37.08.51.17,1,.26,1.5,0-.33,0-.61,0-.65.16-1.3,1.25-3.71,2.69-4a1.74,1.74,0,0,1,2,1.63,3.64,3.64,0,0,1-1.4,2.71,10.77,10.77,0,0,1-3.09,1.44c.1.51.21,1,.34,1.5s.16.65.27,1,.21.64.31,1c.22.61.45,1.23.67,1.82.16.41.32.79.48,1.18-.08-.5-.22-1.49-.22-1.57a6.81,6.81,0,0,1,.9-3.28,2.34,2.34,0,0,1,0-.38,1.73,1.73,0,0,1,2.12-1.47c1.42.37,2.31,2.86,2.38,4.17,0,.07-.05.92-.09,1.45.07-.31.14-.61.22-.93.15-.62.31-1.25.49-1.91.1-.32.19-.65.29-1s.23-.66.35-1c.28-.76.6-1.52.94-2.28a11.63,11.63,0,0,1-3.27-1.23,3.6,3.6,0,0,1-1.59-2.6,1.73,1.73,0,0,1,1.87-1.78c1.46.16,2.72,2.48,3,3.76,0,.08.1,1,.14,1.54.21-.45.41-.91.64-1.36.65-1.32,1.35-2.62,2-3.93.22-.4.42-.8.63-1.2a12.45,12.45,0,0,1-3.39-1.26,3.63,3.63,0,0,1-1.59-2.6,1.75,1.75,0,0,1,1.88-1.78c1.45.16,2.72,2.48,3,3.76,0,.1.15,1.46.16,1.8.46-.88.91-1.77,1.32-2.66a32.23,32.23,0,0,0,1.43-3.69,12.1,12.1,0,0,1-3.41-1.26,3.61,3.61,0,0,1-1.59-2.6,1.73,1.73,0,0,1,1.87-1.78c1.46.16,2.72,2.48,3,3.76,0,.1.15,1.56.15,1.83,0-.08.06-.15.08-.22a22.55,22.55,0,0,0,.74-3.91c.08-.72.12-1.42.14-2.11a11.38,11.38,0,0,1-3.44-.86,3.65,3.65,0,0,1-1.87-2.42,1.74,1.74,0,0,1,1.67-2c1.47,0,3,2.17,3.38,3.41,0,.07.17.79.27,1.31,0-.31,0-.63,0-.92,0-1.11-.07-2.13-.14-3,0-.51-.09-1-.14-1.4a11.51,11.51,0,0,1-2.64-2.34,3.64,3.64,0,0,1-.55-3,1.74,1.74,0,0,1,2.39-1c1.3.68,1.64,3.3,1.43,4.59,0,.11-.51,1.82-.53,1.81l0,0c.06.41.11.86.17,1.34.09.9.18,1.92.2,3a31.72,31.72,0,0,1-.08,3.6,22.16,22.16,0,0,1-.67,4s0,0,0,.05c.23-.36.91-1.35,1-1.42.86-1,3.09-2.4,4.44-1.83a1.73,1.73,0,0,1,.77,2.46A3.62,3.62,0,0,1,485.71,431.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.57,424.25s-.47-1.71-.48-1.82c-.18-1.3.23-3.91,1.55-4.55a1.74,1.74,0,0,1,2.36,1.05,3.62,3.62,0,0,1-.63,3A12.37,12.37,0,0,1,460.57,424.25Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clouds--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M448,89.38c-1.48-7.46-9.15-10.32-14.84-12.82-7.13-3.12-11.13-5.94-14.78-11a67.94,67.94,0,0,1-5.22-8.81c-5.91-11.46-15.94-19.87-27.08-22.71-9-2.3-19.54-.43-25.36,8-4.87,7-7,18.59-14.63,19.82-3.69.6-7.22-1.73-10.46-3.9-4.58-3-9.35-6-14.55-7s-10.93-.08-14.91,4c-5.87,6-7.72,18-15.37,19.74-6.56,1.47-12.8-6.28-19.31-4.55-5.39,1.43-8,8.4-11.56,13.34a22.86,22.86,0,0,1-6.3,5.94Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.5,122.71c-.58-2.95-3.61-4.08-5.86-5.07a12.66,12.66,0,0,1-5.85-4.33,28.11,28.11,0,0,1-2.06-3.48,17.22,17.22,0,0,0-10.7-9c-3.56-.91-7.73-.17-10,3.15-1.92,2.78-2.77,7.35-5.78,7.84-1.46.23-2.85-.69-4.14-1.55a17.13,17.13,0,0,0-5.75-2.79,6.36,6.36,0,0,0-5.89,1.58c-2.32,2.38-3.06,7.13-6.08,7.81-2.59.58-5.06-2.49-7.63-1.8-2.13.56-3.16,3.32-4.57,5.27a8.94,8.94,0,0,1-2.49,2.35Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.77,117.88c-.58-2.95-3.62-4.07-5.87-5.06a12.65,12.65,0,0,1-5.84-4.34A26.25,26.25,0,0,1,168,105a17.24,17.24,0,0,0-10.71-9c-3.56-.91-7.72-.17-10,3.15-1.93,2.78-2.77,7.35-5.79,7.84-1.45.24-2.85-.69-4.13-1.54a17,17,0,0,0-5.75-2.79,6.31,6.31,0,0,0-5.89,1.58c-2.33,2.37-3.06,7.12-6.08,7.8-2.59.58-5.06-2.48-7.64-1.8-2.12.57-3.15,3.32-4.56,5.28a9.22,9.22,0,0,1-2.5,2.34Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.56,256.14c-1-5-6.12-6.91-9.93-8.58-4.78-2.09-7.45-4-9.9-7.34a46.29,46.29,0,0,1-3.49-5.9c-4-7.67-10.67-13.3-18.12-15.2-6-1.54-13.08-.28-17,5.34-3.26,4.7-4.68,12.44-9.79,13.26-2.47.4-4.83-1.16-7-2.6-3.07-2.05-6.26-4-9.74-4.73a10.71,10.71,0,0,0-10,2.68c-3.93,4-5.17,12.06-10.28,13.21-4.39,1-8.58-4.21-12.93-3.05-3.61,1-5.34,5.63-7.74,8.93a15.26,15.26,0,0,1-4.21,4Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.65,286.88c-.4-2-2.42-2.73-3.93-3.39a8.34,8.34,0,0,1-3.91-2.9,17.08,17.08,0,0,1-1.38-2.33,11.56,11.56,0,0,0-7.17-6,6.14,6.14,0,0,0-6.71,2.11c-1.29,1.86-1.85,4.92-3.87,5.25a4.15,4.15,0,0,1-2.77-1,11.38,11.38,0,0,0-3.84-1.86,4.24,4.24,0,0,0-3.95,1.05c-1.55,1.59-2,4.77-4.07,5.23-1.73.38-3.38-1.67-5.11-1.21-1.42.38-2.11,2.23-3,3.53a5.91,5.91,0,0,1-1.67,1.57Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Rocks--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M356.54,341.91S315,294.25,309.53,286s-29.28,0-39.92.89-20.4,16-24.84,19.51-8,22.18-8,22.18-6.21,6.21-8.87,8-3.55,22.18-2.67,25.73,54.12,27.5,60.33,29.27,48.79-2.66,55.88-2.66,29.28-13.3,27.5-25.72S356.54,341.91,356.54,341.91Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.34,370.86a125.24,125.24,0,0,0-1.23-16.56,42.4,42.4,0,0,0-9.57-12.39S315,294.25,309.53,286c-1.17-1.78-3.2-2.78-5.76-3.26-2.18,1.41-4.51,3.35-4.55,5.24-.09,3.58-1.76,27.93-1.76,31.29s1.67,21,1.67,21,5,14.27,8.4,15.11,38.62,21.83,44.5,21.83c2.85,0,6.06,1.32,8.82,1.56A29.88,29.88,0,0,0,367.34,370.86Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.83,487.67,480,464l-15-24-12-14s-28-16-32-16-35-8-35-8l-35,29L238.56,411.1S213,421,210,423s-47,14-52,15-70,49-70,49l54.13.67Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "437.87 442.95 431.9 451.32 413.89 454.64 430.48 467.91 439 472.65 420 471 384.04 443.27 409.63 438.53",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.9,361.1s-12.18-13.87-16.61-13.87-17.75,3.55-21.29,5.32-12.42,23.95-15.08,25.73-26.62,23.06-31,27.5S70,417.31,70,422.63s8,10.65,8,10.65h84.27s25.73-24.84,27.5-33.71S170.9,361.1,170.9,361.1Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.25,371.82S224.41,349.38,219.07,347s-41.72,6.47-41.72,6.47-30.16,14.19-34.6,20.4-3.54,10.65-.88,14.19,107.34,36.38,118,37.26,39-5.32,46.13-19.51S287.25,371.82,287.25,371.82Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.59,389.61l-4.42,3.09s-19.42-7.94-18.09-4.41,29.57,26,30,30,.77,7.39,6.57,9.65,12.41,4.92,16.83,2.27,9.27-3.09,9.27-8.39-2.21-16.77-2.21-16.77S234.68,388.29,231.59,389.61Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "232.89 398.26 260.37 418.63 263.22 421 272.69 414.84 232.89 398.26",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.61,396c-3,8.34-5.32,17.74-13.31,23.06s-30.16,16-37.26,16-57.66-14.19-63.87-18.63-27.5-12.42-33.71-19.51.89-23.07.89-23.07,20.4-15.08,26.51-14.88,52.44-4.64,59.54-2.86,59.43,22.18,59.43,22.18A21,21,0,0,1,379.61,396Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.56,411.1s-23.06-22.18-28.39-26.61-31.93-2.67-37.25-.89S152.51,396,149,400.45s-13.3,26.62-13.3,26.62l9.76,14.19s36.37,3.55,49.67,3.55,37.26-.89,37.26-.89,9.76-8,13.31-16S238.56,411.1,238.56,411.1Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.93,403.2c9,12.57,18.07,16.5,15.71,20s-9.43,1.57-13.75,1.17-8.25,7.47-10.61,11a102.66,102.66,0,0,0-5.48,9.4c13.43,0,36.55-.89,36.55-.89s9.76-8,13.31-16-7.1-16.85-7.1-16.85-23.06-22.18-28.39-26.61C210.17,384.49,200.89,390.63,209.93,403.2Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123,433l22-19,18-3s37-4,41,1,15,20,15,20l-8,19s-1,11-8,15-39,16-39,16H139s-17-11-17-17S123,433,123,433Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219,432s-11-15-15-20a3.77,3.77,0,0,0-1.47-1l-.1.57-.39,2s.79,18.41,2.35,22.33,5.09,10.18,2.35,12.92-8.22,8.62-12.14,12.14-14.1,6.66-18,7.05-7.44-2-14.49-2.35-9.4-.39-12.53.79a63.28,63.28,0,0,0-8.62,4.7s-5.48-3.14-6.66-7.45-4.31-8.22-5.48-8.22-2.35,9.79-2.74,14.49a9.72,9.72,0,0,1-.27,1.49C130.8,476.69,139,482,139,482h25s32-12,39-16,8-15,8-15Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.28,487.16,128,483V472c0-3,8-23,8-29s-13-21-16-23-15-9-18-9-17,2-25,6-22,17-29,23S7.67,488.33,7.67,488.33",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381,440c-2.09-2.09-6.47-5.77-10.84-9.33a98.12,98.12,0,0,0-8-6.39L358,421l-.46,0c-2.2-1.51-4.13-2.8-5.43-3.67-5.32-3.55-23.95-16-31.05-15.08s-39.92,1.77-42.58,6.21-56.77,35.48-56.77,35.48h.76L216,447l-13,19s13,9,16,9,19.69-1.35,26.69-2.35c6.29-.9,49.11,8.62,57.72,10.55a21.05,21.05,0,0,0,3.07.46l53.43,4.11a21.26,21.26,0,0,0,12.33-2.8L386,477s7-4,11-7,4-10,4-13S386,445,381,440Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381,440c-.75-.75-1.81-1.72-3.05-2.8L374.09,440s4.27,9,7.11,10.43,7.11,7.1,7.11,7.1,1.89,6.64-1.43,10.43-22.27,9.95-28.42,10.9a125.36,125.36,0,0,1-15.17.94s8.53-1.89,16.59-3.31,14.69-3.32,16.58-5.22,3.79-5.21,2.37-4.73a102.8,102.8,0,0,1-11.37,3.31c-6.16,1.42-14.69,2.85-20.38,2.85s-16.58.94-19.9.94-44.54-6.16-46.91-6.63a18.89,18.89,0,0,1-4.26-1.42s-2.84,2.84,4.26,4.26,6.64,3.32,21.33,5.22,29.37,4.73,27,5.21-9,.94-19-1-16.11-1.42-21.79-3.79a132.28,132.28,0,0,0-16.59-5.69c-8-2.37-11.84-3.31-20.85-3.79s-12.32-.47-16.11-.47-7.58,5.21-12.79,6.16c-2,.37-4.87.81-7.56,1.21,2.19,1.21,4.1,2.09,5,2.09,3,0,19.69-1.35,26.69-2.35,6.29-.9,49.11,8.62,57.72,10.55a21.05,21.05,0,0,0,3.07.46l53.43,4.11a21.26,21.26,0,0,0,12.33-2.8L386,477s7-4,11-7,4-10,4-13S386,445,381,440Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344,317.81s-10,9-10,13,6,21,6,24,15,43,18,53,7,20,9,23,7,11,7,11l8.55,6.24a38.67,38.67,0,0,0,20.56,7.37l13.48.78a24.06,24.06,0,0,0,21.51-10.81l7.15-10.88a23.78,23.78,0,0,0,4-14.13c-.22-4.57-1.8-8.07-8.26-16.57-4.23-5.58-56-59-62-65S350,313.81,344,317.81Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401,457c8,6,14,15,25,15,10,0,25,0,26.47,13.18",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.3,461.17c-2.08.91-4,1.69-4.9,2-2.84.95-12.32,2.37-26.53,2.37H298.28",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.62,457l-4.43,2",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351,454.83A117.05,117.05,0,0,0,363.19,449l-4.73-4.26",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.05,459c3.91-.06,7.44-.1,9.49-.1,6.63,0,47.38,1.42,59.22.47a47,47,0,0,0,11-2.54",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.63,459.38l8.53-.17",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.48,433.06c-2.9-2.75-6.44-5.9-6.44-5.9",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.82,402.19s2.6,5.54,5,9.33,4.63,13,2.43,17.52-6.69,12.33-13.33,14.7-14.68,4.74-18.47,2.85-18-8.06-19.43-9.95",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.12,434.92c-2.54,3.14-2.83,5-5.76,7.14s-18.57,5.47-18.57,5.47l-14.22,2.85-13.26-6.16-17.06-9.48s9.47,9,12.32,11.37,8.53,5.21,10.42,6.16,11.37,2.84,14.22,2.84c2.54,0,10.36.38,15.38.46a24,24,0,0,0,14.52-10.18l7.15-10.88a23.78,23.78,0,0,0,4-14.13c-.22-4.57-1.8-8.07-8.26-16.57l.36,10.08S442.65,431.78,440.12,434.92Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.29,388.87s-1.17,2.35,2.35,5.49,13.71,7.83,13.71,7.83",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 256.88,
    y1: 403.76,
    x2: 263.54,
    y2: 406.89,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 243.56,
    y1: 401.8,
    x2: 265.89,
    y2: 412.37,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.24,422.32s-42.24,40-42.24,42S386,477,386,477s19.67,4.67,23,4.67,13.33-2,17.33-5.34,16-4,18-13.33,8-12.42,4.68-21.87S441.48,415,423.24,422.32Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443,437.67c-.48,6.3,2.1,13.64-.39,19.69C439.64,464.55,431,467,425,471",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.41,453.71c-5,6.08-10.34,11.67-17.74,14.62",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389,475s12,2,16.67,2.67,15.33-2,15.33-2",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.28,487.16,128,483V472c0-3,8-23,8-29,0-3.19-3.68-8.93-7.57-13.9.3,2.48,1.24,10.33,1.24,12.57,0,2.66-6.67,16-10.67,16.66s-20.67-2-20.67-2-18-1.33-22,5.34-11.33,18-11.33,18l-11,8Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.52,458c-3.76,2.49-6.33,4.41-6.33,4.41",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.6,447l-16.33,7.95s-11.48.44-14.13.44c-1.92,0-6.16-.93-10.19-.26",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126,439.27a40.28,40.28,0,0,0,.55-4.64",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.14,453.17s11,1.77,14.13,0,6.62-7.94,7.5-9.27a5.72,5.72,0,0,0,.57-1.52",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.38,449.12c-2.21.05-4.38.08-6.16.08-6.62,0-12.36.44-14.56,3.53s-4.42,11-4.86,13.69a41,41,0,0,0-.44,5.73",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.76,448.76,104,449",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M166.34,372.13S200.42,376,205.17,376s14.23.43,16.39-.43,9.06-6,9.06-6l11.65-1.73a36.6,36.6,0,0,1,5.61-2.58c1.72-.44,12.08.86,12.08.86l18.12,1.72s15.1-12.08,17.25-14.66-3-33.66-3-35.81,4.32-15.53,5.18-19S299.22,288,299.22,288l-38.4,4.75s-9.06,15.1-10.79,19a17.27,17.27,0,0,0-1.72,8.2,79.44,79.44,0,0,1-.86,9.06c-.43,3-4.75,6.47-6.47,7.33s-10.36,4.31-10.36,4.31-1.72,7.34-1.72,9.5a18.06,18.06,0,0,0,.86,4.74s-7.34,3.88-9.49,5.18-9.93,3.45-15.53,4.31-18.56,1.73-23.3,3S166.34,372.13,166.34,372.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.31,127a26.28,26.28,0,0,0-5.92,10.32c-1.72,6.11,1.91,8.78,4.77,11.07s2.49,3.63,1,6.11a3.64,3.64,0,0,0,1.72,5.35c1.52.57,3.82.38,3,3.44s-1.33,4.77.57,5.35,5.54,1.71,4.59,4-.38,5.34.95,5.53,3.06-1.33,3.06.77-2.68,3.82.19,5.54,4.58,1.33,4.39,2.29-1.34,2.1-.76,3.63,2.67,1.33,2.86,2.29-1,1.72-.57,3.63,1.14,2.1,3.05,2.48,1.91.38,1.91,1.91-.38,1.72,1.72,1.91,4.2-.38,6.88-2.48,5.54-12.42,6.49-16.62,2.87-10.12.19-17.57-14.89-31.13-18.71-35.52a19.71,19.71,0,0,0-13.75-6.3C215.13,124.12,211.31,127,211.31,127Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.69,225.25s.32,1.29-2.09,2.74-3.22.64-3.38,2.73-.16,2.74-.48,3.22-4.35,2.58-6.12,3.22a11.33,11.33,0,0,0-3.22,1.93l-.32,6.44a31.71,31.71,0,0,0,7.73-1,47,47,0,0,1,6.76-1.45s1.6,1.13,3.37-6.27S242.11,223.48,239.69,225.25Z",
    style: {
      fill: "gray",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232,240.54c.2-2.85-.95-4-1.82-4.51a27.33,27.33,0,0,1-2.53,1.13,11.33,11.33,0,0,0-3.22,1.93l-.32,6.44a34.13,34.13,0,0,0,7-.77A14.88,14.88,0,0,0,232,240.54Z",
    style: {
      fill: "#a8a8a8",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.85,217.12s2.1,11.65-1.14,17.19-1.53,12.41.19,14.7,3.82,1.91,5,.38,4-9.54,3.44-20.43S239,213.68,237.85,217.12Z",
    style: {
      fill: "gray",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.87,176.83s-10.31,27.88-10.12,35.33,6.88,14.32,7.26,15.66-.38,11.26-1.53,14.51-3.44,9.36-3.44,9.36A33.31,33.31,0,0,0,253.89,257a48.37,48.37,0,0,0,16.05-2.1l3.81-2.48s-5.53-14.13-9-25.78-5-36.86-4.58-45.64.76-11.84-2.49-12S247.4,174.15,245.87,176.83Z",
    style: {
      fill: "#00A848",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.23,252.51s-20.84.89-35.26,6.21-21.73,7.76-21.95,15.52,11.09,36.15,11.09,36.15,12,32.82,12.41,34.82a7.42,7.42,0,0,1-.22,4.66c-.44.66,1.56,5.54,6.21,5.54s8-3.55,8.65-8.43-2.44-8.87-4-16.85-4.44-25.95-4.44-32.38-2.21-14.64-2.21-14.64,17.07,5.77,26.39,8.65,36.81,2.22,41.91,1.33,4.66-7.54.23-17.3-18.41-16.41-23.29-18.62S240.23,252.51,240.23,252.51Z",
    style: {
      fill: "#a8a8a8",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.76,257.17c-4.88-2.22-15.53-4.66-15.53-4.66s-20.84.89-35.26,6.21-21.73,7.76-21.95,15.52,11.09,36.15,11.09,36.15,6.17,16.92,9.81,27.2a23.77,23.77,0,0,0,13.3-7.25,1.6,1.6,0,0,1-.05-.21c-1.53-7.85-4.44-25.95-4.44-32.38s-2.21-14.64-2.21-14.64,17.07,5.77,26.39,8.65,36.81,2.22,41.91,1.33,4.66-7.54.23-17.3S260.64,259.38,255.76,257.17Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207,350.2s-.6-2-1.61-.4-1,4.23-1.82,5-2.62,4.44-7.06,6.66-8.47,3.43-8.88,5,2.43,3,6.86,3.23,13.32.4,17.15-.6,6.06-3.43,10.29-4.85,7.06-1.61,7.87-3.43-2.82-11.29-4.44-13.11-2.42-4.44-4-4.44-2,2-2.22,3.63-.41,3.84-4.44,4.84S207,350.2,207,350.2Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.76,367.55c-6.36,1.47-15.76-.36-19.12-1.11a.47.47,0,0,0,0,.1c-.4,1.62,2.43,3,6.86,3.23s13.32.4,17.15-.6,6.06-3.43,10.29-4.85,7.06-1.61,7.87-3.43c.27-.6,0-2.05-.43-3.78-1.08.43-2.43,1-4,1.77C221.09,360.89,214.63,365.74,206.76,367.55Z",
    style: {
      fill: "#00A848",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.67,252.73s-18.19,4.66-29.06,7.32-18.18,4.88-18.85,12.64-8.2,61.87-9.53,65.64-4,14.42-4,17.08a6.23,6.23,0,0,0,6,6.21c4.22.44,6.43-1.55,7.1-3.55s2.66-7.54,5.1-15.52,12-22,14.42-33.49a82.16,82.16,0,0,0,1.33-22.4,131.63,131.63,0,0,1,18,4.22c9.09,2.88,34.37,3.54,48.57,2.43s18.18-9.09,18.41-15.52-6.21-17.52-10-21.29-10.65-4.66-23.29-4.88A206.91,206.91,0,0,0,246.67,252.73Z",
    style: {
      fill: "#a8a8a8",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.11,277.79c.22-6.43-6.21-17.52-10-21.29s-10.65-4.66-23.29-4.88a206.91,206.91,0,0,0-24.17,1.11s-18.19,4.66-29.06,7.32-18.18,4.88-18.85,12.64-8.2,61.87-9.53,65.64c-.27.76-.59,1.79-.93,3a30.54,30.54,0,0,0,14.27,4c.27-.88.56-1.8.85-2.75,2.44-8,12-22,14.42-33.49a82.16,82.16,0,0,0,1.33-22.4,131.63,131.63,0,0,1,18,4.22c9.09,2.88,34.37,3.54,48.57,2.43S303.88,284.22,304.11,277.79Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185,351.42s-.47-.69-2.34,1.39a34.33,34.33,0,0,1-11.71,8.29c-5.63,2.3-11.72,3-13.36,4.83s-.46,4.38,0,5.07,16.4,2.3,24.36,2.3,17.57-.23,19.21-.92,1.87-5.07,1.64-7.83-1.4-4.38-1.4-5.76.7-3.68,0-4.6-3.75,1.84-5.39,3-7.5.92-8.67-.23S185.89,351.42,185,351.42Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.54,370.31c-9.67,0-21.9-1.26-26.83-1.82a5.63,5.63,0,0,0,.83,2.51c.47.69,16.4,2.3,24.36,2.3s17.57-.23,19.21-.92c.89-.38,1.37-1.84,1.58-3.54A132.48,132.48,0,0,1,183.54,370.31Z",
    style: {
      fill: "#00A848",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.61,132.9s-4,5.73-3.63,10.13,1.91,5.53,3.06,6.87a7.69,7.69,0,0,1,1.91,6.68c-.58,3.25-1.53,3.82-1,5.16s4.39,1.72,4.39,1.72a94.1,94.1,0,0,0,6.69,6.87c2.1,1.72,4,2.68,6.11,1.34a39.54,39.54,0,0,0,4.77-3.44c.58-.57,5,5.73,5.73,9.74s-2.29,8.41-.57,9,4.58-4.39,6.49-9.36,3.82-5.92,3.82-5.92-10.88-22.34-17.95-31.7-14.13-10.5-16.61-9.74A5.14,5.14,0,0,0,217.61,132.9Z",
    style: {
      fill: "#a8a8a8",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.73,163.08s3.63-1,4-3.82",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.76,149.9s2.48,4,4.39,4.39,5.15-.76,5.73-3.43-1.15-5.54-1.15-5.54S222,146.46,218.76,149.9Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.76,149.9l-3.06,2.29a4.46,4.46,0,0,0,2.87,2.68",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 227.73,
    y1: 145.32,
    x2: 238.04,
    y2: 141.31,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.19,151.24c.49.95.6,1.87.24,2.06s-1.05-.43-1.54-1.38-.61-1.88-.25-2.06S224.69,150.29,225.19,151.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.14,147.23a4.47,4.47,0,0,1,4.39-2.49",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.61,131.38a2.54,2.54,0,0,0,1.91,3.05c2.48.77,5.16-.19,4.77,2.68s-2.1,4.2,1.34,4.77,4.78,0,4.78,3.82-2.49,5.16,1.52,6.11,6.11.38,5.54,4.58-2.86,5.73.19,6.88,5.35-.57,5.35,2.67,0,5.16,1.91,5.54,3.44-2.1,3.82.57.57,4,2.1,4.2,1.91-1.52,4-.95,10.31-3.44,12.79-6.11,6.69-2.1,9.93,2.29,9.93,18.71,10.32,21.58.95,3.44,3.24.19,4.2-6.49,2.29-9.74-3.24-2.67-1.91-6.3,4-5.16,1.34-8.4-3.44-2.49-2.86-6.88,1.52-5-1.34-6.68-3.82-1.91-3.82-4.78,1.34-4.77-1.34-6.3-3.43-1.14-3.43-3.63.57-3.43-1.34-4.77-3.63-2.29-3.63-4.77,0-2.68-1.72-4a7.38,7.38,0,0,1-3.05-4.77c-.19-1.72-1.15-3.44-2.49-3.82s-2.29.77-3.24-1.53-1.53-3.43-3.25-3.62a7.18,7.18,0,0,1-4.77-2.68c-1.15-1.53-1.91-2.29-3.44-1.72s-5.16.77-6.68-.57-4-2.1-5.92-.57A5.73,5.73,0,0,1,235,109c-1.72-.57-3.44-.57-4.58.58s-1,1.91-3.25,1.33-4.39-.57-5.54,1.15a8.61,8.61,0,0,1-3.63,3.06c-1.14.57-3.82,1.14-4.2,3.24s-.19,3.06-1.14,3.82-2.49,2.67-2.49,4,2.29,3.82,4.59,4.2",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.7,177s-.95,26.16-1.72,39.34,3.25,17.95,5.73,21.19,25.78,34,27.12,37.24,2.67,9,3.25,9.55,6.3-.19,10.5-1.34,6.68-5.34,6.68-5.34,1.15-5.16-1.71-13.37-6.5-13.56-6.88-19.29-3.25-25.4-4.2-34.56a173.22,173.22,0,0,0-5.54-26.55c-1.72-5.92-3.44-10.12-6.3-12.79a28.75,28.75,0,0,0-6.49-4.39Z",
    style: {
      fill: "gray",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.13,264.48l-3.05,19.86-5.54-11.46S289.41,264.67,291.13,264.48Z",
    style: {
      fill: "#575757",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.14,236.79s17.76,15.47,25.21,20.82,8.78,6.87,8.78,6.87S281,279.57,280.44,279.57s-4-8.21-7.83-14.52S257.52,239.85,257.14,236.79Z",
    style: {
      fill: "gray",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "272.42 160.79 251.6 173.77 254.28 180.84 276.62 166.13 272.42 160.79",
    style: {
      fill: "gray",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "194.63 257.76 216.84 265.64 249.67 252.61 228.87 246.38 194.63 257.76",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "226.96 257.49 224.08 256.57 220.63 257.96 223.65 258.94 226.96 257.49",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "220.38 254.33 225.75 252.33 224.15 251.87 218.78 253.81 220.38 254.33",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "213.58 255.7 215.25 256.23 218.86 254.89 217.24 254.37 213.58 255.7",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "210.29 254.64 212.02 255.2 215.69 253.87 213.98 253.32 210.29 254.64",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "210.49 255.75 208.55 255.13 205.75 255.9 208.01 256.65 210.49 255.75",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "224.04 255.5 229.32 253.37 227.36 252.8 221.92 254.82 224.04 255.5",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "217.7 258.07 215.27 257.29 212.75 258.23 215.25 259.06 217.7 258.07",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "206.25 259.57 209.74 258.28 208.02 257.71 204.5 258.98 206.25 259.57",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "222.59 256.09 220.4 255.39 216.79 256.73 219.14 257.49 222.59 256.09",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "209.54 257.16 211.23 257.73 213.73 256.8 212.04 256.25 209.54 257.16",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "206.49 257.2 204.02 256.38 200.03 257.47 202.99 258.47 206.49 257.2",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "219.9 261.67 216.65 263.09 218 263.54 221.54 262.22 219.9 261.67",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "230.87 253.82 225.52 255.98 228.34 256.89 233.57 254.6 230.87 253.82",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "217.22 253.31 222.52 251.4 220.78 250.89 215.53 252.77 217.22 253.31",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "229.78 257.35 232.34 258.17 238.24 255.95 235.07 255.04 229.78 257.35",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "218.48 261.2 215.28 260.13 211.92 261.49 215.24 262.61 218.48 261.2",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "222.27 259.54 219.18 258.55 216.71 259.55 219.85 260.6 222.27 259.54",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "211.25 258.79 207.76 260.08 210.47 261 213.82 259.64 211.25 258.79",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "225.72 260.65 223.71 260 221.27 261.07 223.03 261.66 225.72 260.65",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "225.09 259.4 227.23 260.08 230.83 258.73 228.4 257.95 225.09 259.4",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "216.84 265.64 201.39 230.24 176.93 226.54 190.59 257.05 216.84 265.64",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.11,188.67s-3.06,7.83-2.49,14.13,5.92,19.67,6.69,23.49a11.36,11.36,0,0,1-.19,6.11s-1-1.15-1.72.95-3.06,7.83-3.06,7.83l-1.91,1,7.83,14.7,2.48,4.2s5.73-2.86,7.83-4.77,7.64-3.44,9.93-6.3.77-2.87,2.49-7.07,2.67-13.75,1.52-16.61-2.29-3.63-2.29-6.5,2.68-7.82.58-15.46-3.63-19.67-7.07-22.92-6.3-2.67-8.21-2.67",
    style: {
      fill: "gray",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.12,243.31a12.75,12.75,0,0,0,2.51,1.5",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.83,235.45s4.48,3.61,8.19,6.35",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.23,235.64s11.65,3.44,11.07,4.59-5.53-1.15-6.49-1.53",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.75,248.63s-17.95,10.31-19.29,10.31-5.54-3.05-6.87-2.67a54.78,54.78,0,0,0-5.16,2.29c-1.72.76-5-.19-5.16,1.15s1.34,2.29,1.34,2.29-3.82.76-4.58.76-1.72,1.53,0,2.87,4.77,1.52,5.34,1.72,3.82,1.91,6.5,1.91,8.21-2.87,11.84-3.82,22.34-6.12,22.34-6.12S255.61,248.63,252.75,248.63Z",
    style: {
      fill: "#a8a8a8",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.61,262a16.23,16.23,0,0,0,6.88-.19",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.72,240s5.92,9.16,9.36,15.27,2.29,6.5,1.34,7.45-8,2.1-10.31,2.48a3.76,3.76,0,0,1-4.59-3.43c0-2.29-2.86-8.21-4-10.31s-2.86-1.72-2.86-3.44,3.82-4,5.54-5.54S260.39,239.85,261.72,240Z",
    style: {
      fill: "gray",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.29,233.62s5.31,2.41,7.08,3.54,4.51,2.25,4.34,3.54-3.54,5.31-5,5.63-4.51-1.93-6.44-1.93-3.7-5.15-3.06-6.92S217,233.78,218.29,233.62Z",
    style: {
      fill: "#a8a8a8",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.37,240.54s-1.61,1.45-1.61,2.73.81,5.15,1.77,6,1.45-.32,1.45-1.29-1.45-1.77-.81-3.06,1.45-3.38,1.45-3.38S212.66,239.9,211.37,240.54Z",
    style: {
      fill: "#a8a8a8",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.59,238.45a3.52,3.52,0,0,0-3.22,1.28c-1.13,1.61-.16,3.38.8,5.15a5,5,0,0,0,3.87,2.58c1.28.16,1.93-.32.8-1.77a16.74,16.74,0,0,1-2.09-4.51A18.62,18.62,0,0,1,214.59,238.45Z",
    style: {
      fill: "#a8a8a8",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.84,234.42s-3.06,1.77-3.06,3.22a21.43,21.43,0,0,0,1.45,6.6c.81,1.77,3.22,4,3.54,3.22s-.32-2.9-.64-4.51-.81-7.56-.81-7.56A.6.6,0,0,0,216.84,234.42Z",
    style: {
      fill: "#a8a8a8",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.38,235.87s-1.45-2.73-3.22-2.73-.64,1.93-.48,5.63,1,7.4,2.09,8.69,1.77.32,1.45-1.93-.48-5.63-.48-6.12v-1.12",
    style: {
      fill: "#a8a8a8",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.89,240.54a7.68,7.68,0,0,1-1.29,3.22c-1,1.12-2.09,3.05-1.29,3.54s1.61,0,2.42-1,2.89-2.73,3.86-4.5a2.7,2.7,0,0,0-1.45-3.87,15.25,15.25,0,0,0-1.93-.16",
    style: {
      fill: "#a8a8a8",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.63,366.5s10.48,13.24,20.55,13.24,19.31-1.68,26-1.68,23.51-2.52,28.55-5,2.52-5-1.68-7.55-25.19-12.6-25.19-12.6Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.42,309.06a255.14,255.14,0,0,1-14.63,21.07c-8,10.2-12.2,12.2-14,16.85s-.89,9.1.66,10.21,17.3,4.21,21.29,4.43a42.47,42.47,0,0,0,8.65-.66l.44-2s-7.09.22-8.87,0-8.87-5.32-11.31-6.88-3.55-2.21-3.55-2.21a204.54,204.54,0,0,1,13.53-15.75,105.76,105.76,0,0,0,12.42-16S259.75,306.84,256.42,309.06Z",
    style: {
      fill: "#a8a8a8",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.13,349.87s-2.88,4-2.88,5.54",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.91,286.66s-20.18,4-24.84,4.88-6.65,2.22-9.09,7.76-3.77,7.76-2.66,13.09,1.55,24.39,1.55,32.6-1.78,13.75-.45,16.41,5.1,4.21,6.21,5.1,10,4,12.64,4.66,6.44,3.55,9.76,3.55,10.87-2.67,16-4.88,12.64-1.78,16.41-3.55,5.55-3.11,4.66-7.76-4.44-7.77-5.1-13.09-.22-13.3-1.33-17.3-3.77-8.65-4.44-15.52.45-16-2-19.3-1.56-2.66-5.77-4.21S295.68,284.67,291.91,286.66Z",
    style: {
      fill: "#a8a8a8",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.81,296.64c10-2.22,12.42-3.1,16-4.88s5.11.22,5.11.22l.25-.15c-1.21-1.67-1.26-1.47-4.69-2.73-4.21-1.55-7.76-4.43-11.53-2.44,0,0-20.18,4-24.84,4.88s-6.65,2.22-9.09,7.76-3.77,7.76-2.66,13.09,1.55,24.39,1.55,32.6-1.78,13.75-.45,16.41,5.1,4.21,6.21,5.1a30.32,30.32,0,0,0,5,2.13.51.51,0,0,0-.09-.58c-1.55-1.77.67-8.87,2-18.4s.89-25.07-.44-29.5-4-9.54-2.22-14.42S276.83,298.86,286.81,296.64Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.16,332.13s-.89,25.5-1.55,31-1.55,6.43-.89,7.54,7.54,3.77,10,3.77,3.33.23,3.55-2.66-2-23.51-1.77-28.38,1.55-9.76-1.11-11.31S278.82,326.8,276.16,332.13Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.71,318.15s-13.08,4.44-21.29,7.1-11.09,2.44-11.53,5.1,0,2.66,1.11,3.11a9.14,9.14,0,0,1,4.43,5.54c1.11,3.33,2.22,6,3.77,6s24.4-3.55,28.17-5.1,5.32-2,4.88-4.44-.67-6.65-1.56-11.75S312.26,316.82,308.71,318.15Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "290.36 339.22 292.35 355.86 295.68 354.75 293.25 338.36 290.36 339.22",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "310.6 335.39 313.64 350.98 316.52 350.09 313.64 334.34 310.6 335.39",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.17,308.17s7.31-1.55,16.19-3.77,17.07-4.88,17.07-4.88V302s-10,3.11-15.3,4.22-10.42,1.77-11.31,2-3.55.89-4.88,1.33l-1.33.45Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignup);
export default __webpack_public_path__ + "static/media/signup.5f4d372d2d832175b596a54ac0fda46d.svg";
export { ForwardRef as ReactComponent };